import * as tslib_1 from "tslib";
/* tslint:disable */
import 'react-hot-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from '@souche-f2e/muji';
import Root, { router } from './Root';
import store from './store';
import { createRouterPlugin } from '@souche-f2e/muji';
import { createSSOPlugin } from './sso';
import { dispatch } from './store';
const init = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
    store.use(createRouterPlugin(router));
    store.use(createSSOPlugin({ "mode": "prod", "forceRedirect": false }));
    store.init();
    yield dispatch.sso.loadSSOUser();
    router.init();
    store.triggerSetupFns();
});
const App = () => (<Provider store={store}>
    <Root />
  </Provider>);
const render = () => {
    ReactDOM.render(<App />, document.getElementById('root'));
};
init()
    .then(() => {
    if (store.getState().sso) {
        if (store.getState().sso.isLogin || store.getState().sso.forceRedirect === false) {
            render();
        }
    }
    else {
        render();
    }
})
    .catch((err) => {
    if (process.env.NODE_ENV === 'development') {
        console.error(err);
    }
});
